import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/ubicaciones`;

export async function getDepartamentos(flag = 1) {
  const { data } = await axios.get(
    `${baseUrl}/departamentos?flag=${flag}`
  );

  return data;
}
export async function getMunicipios(departamentoId, bandera = 1) {
  if (!departamentoId || isNaN(departamentoId)) {
    return { success: true, data: [] };
  }
  const { data } = await axios.get(
    `${baseUrl}/municipios/${departamentoId}`,
    {
      params: { bandera }
    }
  );
  return data;
}

export async function getCorregimientos(municipioOid) {
  if (!municipioOid) return { success: true, data: [] };
  const { data } = await axios.get(`${baseUrl}/corregimientos/${municipioOid}`);
  return data;
}

export async function getBarrios(municipioOid) {
  if (!municipioOid) return { success: true, data: [] };
  const { data } = await axios.get(`${baseUrl}/barrios/${municipioOid}`);
  return data;
}

export async function getVeredasByMunicipio(municipioOid) {
  if (!municipioOid) return { success: true, data: [] };
  const { data } = await axios.get(`${baseUrl}/veredas/municipio/${municipioOid}`);
  return data;
}

export async function getVeredasByCorregimiento(corregimientoId) {
  if (!corregimientoId) return { success: true, data: [] };
  const { data } = await axios.get(`${baseUrl}/veredas/corregimiento/${corregimientoId}`);
  return data;
}

export async function getZonas() {
  const { data } = await axios.get(`${baseUrl}/zonas`);
  return data;
}

// =======================
// SEARCH (autocomplete)
// =======================
export async function searchMunicipios(q, departamentoId) {
  const { data } = await axios.get(`${baseUrl}/search/municipios`, {
    params: { q, departamentoId }
  });
  return data;
}

export async function searchBarrios(q, municipioOid) {
  const { data } = await axios.get(`${baseUrl}/search/barrios`, {
    params: { q, municipioOid }
  });
  return data;
}

export async function searchCorregimientos(q, municipioOid) {
  const { data } = await axios.get(`${baseUrl}/search/corregimientos`, {
    params: { q, municipioOid }
  });
  return data;
}

export async function searchVeredas(params) {
  const { data } = await axios.get(`${baseUrl}/search/veredas`, { params });
  return data;
}
